import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Client-side gate. Server-side role and tenant checks remain the authority. */
export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p className="p-16 text-sm text-slate-500" data-testid="auth-loading">Checking your access…</p>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (roles && !hasRole(...roles)) {
    return (
      <div className="max-w-2xl mx-auto px-5 py-20 text-center" data-testid="access-denied">
        <h1 className="text-3xl font-semibold">You do not have access to this area</h1>
        <p className="mt-4 text-sm text-slate-600">
          This area requires one of the following roles: {roles.join(", ").replace(/_/g, " ")}. Your account
          holds: {user.roles.join(", ").replace(/_/g, " ")}. Server-side checks also enforce this, so the
          underlying APIs will refuse requests from your account.
        </p>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
